"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextArea = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _isEqual2 = _interopRequireDefault(require("lodash-es/isEqual"));

var _input = require("../_input");

var _tokens = require("../../../tokens");

var _context = require("../../context");

var _versions = require("../../_utils/versions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  resize: ", ";\n  font-size: ", ";\n  padding: ", ";\n  vertical-align: top;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-top: ", ";\n  margin: 10px 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTextArea = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.label ? _tokens.spacing.medium : 0;
});

exports.StyledTextArea = StyledTextArea;

var StyledTextInputArea = _input.StyledInput.withComponent('textarea').extend(_templateObject2(), function (props) {
  return props.resizable ? 'vertical' : 'none';
}, function (props) {
  return props.code ? '13px' : 'inherit';
}, function (props) {
  return props.bordered ? '9px 16px' : '0 4px 4px 0';
});

var TextArea =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextArea, _React$Component);

  //eslint-disable-line
  function TextArea(props) {
    var _this;

    _classCallCheck(this, TextArea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextArea).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      if (!(0, _isEqual2["default"])(nextProps.value, _this.state.value)) _this.setState({
        value: nextProps.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      e.persist();
      var value = e.target.value;

      _this.setState({
        value: value
      }, function () {
        return _this.props.onChange(e);
      });
    });

    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  _createClass(TextArea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          length = _this$props.length,
          label = _this$props.label,
          value = _this$props.value,
          rest = _objectWithoutProperties(_this$props, ["length", "label", "value"]);

      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          onBlur = _this$props2.onBlur,
          onKeyDown = _this$props2.onKeyDown,
          onKeyPress = _this$props2.onKeyPress,
          onKeyUp = _this$props2.onKeyUp,
          onFocus = _this$props2.onFocus,
          onClick = _this$props2.onClick,
          wrapperProps = _objectWithoutProperties(_this$props2, ["onChange", "onBlur", "onKeyDown", "onKeyPress", "onKeyUp", "onFocus", "onClick"]);

      return _react["default"].createElement(StyledTextArea, wrapperProps, _react["default"].createElement(StyledTextInputArea, _extends({}, rest, {
        rows: length,
        onChange: this.onChange,
        value: this.state.value
      })), _react["default"].createElement(_input.StyledLabel, _extends({}, rest, {
        textarea: true
      }), label), _react["default"].createElement(_input.StyledError, {
        version: this.props.version,
        errorCasing: (0, _versions.getProperties)(this.props, 'textarea').errorCasing
      }, this.props.error));
    }
  }]);

  return TextArea;
}(_react["default"].Component);

TextArea.propTypes = {
  /** Length of the textarea in rows */
  length: _propTypes["default"].number,

  /** Make input readOnly if it does not validate constraint */
  readOnly: _propTypes["default"].bool,

  /** Use when the expected input is code */
  code: _propTypes["default"].bool,
  required: _propTypes["default"].bool,

  /** Pass error string directly to show error state */
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),

  /** Allow resizing of the textarea */
  resizable: _propTypes["default"].bool,
  bordered: _propTypes["default"].bool,

  /** onChange transparently passed to the input */
  onChange: _propTypes["default"].func,
  labelType: _propTypes["default"].oneOf(['floating', 'static'])
};
TextArea.defaultProps = {
  length: 3,
  readOnly: false,
  code: false,
  error: null,
  resizable: true,
  labelType: 'floating',
  bordered: false,
  onChange: _noop2["default"],
  required: true
};
TextArea.displayName = 'TextArea';

var _default = (0, _context.withVersion)(TextArea);

exports["default"] = _default;